import * as firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyBz98QuvztyU8k433NBhhLlSkSQ5OB2z0Y',
  authDomain: 'food-2760b.firebaseapp.com',
  databaseURL: 'https://food-2760b.firebaseio.com',
  projectId: 'food-2760b',
  storageBucket: 'food-2760b.appspot.com',
  messagingSenderId: '934350458039',
  appId: '1:934350458039:web:a5a1e3f7b6f01fe6a19132'
};

firebase.initializeApp(config);
const databaseRef = firebase.database().ref();
export const itemsref = databaseRef.child('items');
export default firebase;
